"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepMemo = void 0;
const react_1 = require("react");
const deep_object_diff_1 = require("deep-object-diff");
function useDeepMemo(obj) {
    const prevObjRef = react_1.useRef(obj);
    const prevObj = prevObjRef.current;
    const differences = deep_object_diff_1.diff(prevObj, obj);
    if (Object.keys(differences).length > 0) {
        /* notice this is the original object, not the stripped obj. */
        prevObjRef.current = obj;
    }
    return prevObjRef.current;
}
exports.useDeepMemo = useDeepMemo;
